import React from 'react';
import { CtaButton } from './CtaButton';
import { finalHighlights } from '../data/coachSystem';
export function FinalCtaSection() {
  return <section className="border-t border-char-line bg-char py-12 sm:py-16" aria-labelledby="final-cta-title" data-id="element-47" data-mp="3lslmptpz65nq">
      <div className="mx-auto w-full max-w-[42rem] px-4 text-center sm:px-6 lg:max-w-3xl" data-id="element-48" data-mp="3vsm95oj551w5">
        <h2 id="final-cta-title" className="font-display text-[1.85rem] font-semibold uppercase leading-[1.08] tracking-tight text-ivory sm:text-[2.4rem]" data-id="element-49" data-mp="3vq9v3mgi7bod">
          Everything you need to plan, teach and coach — in one complete
          system.
        </h2>

        <span className="mx-auto mt-5 block h-[2px] w-8 rounded-full bg-orange" aria-hidden="true" data-id="element-50" data-mp="380yqftw18x4y" />
        <p className="mt-3.5 font-display text-[0.8rem] font-semibold uppercase text-orange" style={{
        letterSpacing: '0.24em'
      }} data-id="element-51" data-mp="2femaegw17iah">
          Basketball Coach System™
        </p>

        <ul className="mx-auto mt-4 flex max-w-xl flex-wrap items-center justify-center gap-x-3 gap-y-2" data-id="element-52" data-mp="2dcjl3jvmip2t">
          {finalHighlights.map(item => <li key={item} className="rounded-full border border-char-line bg-char-light px-3.5 py-1.5 text-[0.82rem] font-medium text-ivory-soft shadow-card" data-id="element-53" data-mp="28dp1wgtquyi6">
              {item}
            </li>)}
        </ul>

        <CtaButton label="Get the complete system" size="lg" className="mt-7 sm:w-auto" data-id="element-54" data-mp="1umjzj6yzrs45" />
      </div>
    </section>;
}